import React, { useEffect, useState } from 'react';
import { CardElement, useStripe, PaymentElement, useElements, AddressElement } from '@stripe/react-stripe-js';
import { CardNumberElement, CardExpiryElement, CardCvcElement } from '@stripe/react-stripe-js';
import { Alert, Button, Col, Form, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row, Spinner } from 'reactstrap';
import axios from 'axios';
import { useAppDispatch, useAppSelector } from '../../../../../app/config/store';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router';
import PaymentDoneModal from './paymentDone';
import { getEntity } from '../../entities/case-forms/subscription-plan.reducer';

type CouponResult = {
  amount_off: number | null;
  percent_off: number | null;
};

const PaymentForm = props => {
  const stripe = useStripe();
  const elements = useElements();
  const [loader, setLoader] = useState<boolean>(false);
  const [isPromoCode, setIsPromoCode] = useState<boolean>(false);
  const [promoCode, setPromoCode] = useState('');
  const [isPaymentDone, setIsPaymentDone] = useState<boolean>(false);
  const [enableApply, setEnableApply] = useState<boolean>(false);
  const [isApplied, setIsApplied] = useState(false);
  const getStep: any = localStorage.getItem('step');
  const [planView, setPlanView] = useState<any>('');
  const [fieldErrors, setFieldErrors] = useState<any>({
    cardNumber: '',
    expiry: '',
    cvc: '',
  });
  const [amount, setAmount] = useState<any>({ discount: '', total: 0 });
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { id, email, firstName, lastName } = useAppSelector(state => state.authentication?.account);
  const CoupenList = {
    DOYOUHAVEACASE90: '90%',
    '1DOYOUHAVEACASE': '$1',
    DOYOUHAVEACASEBETA: '70%',
    SHAREDOYOUHAVEACASE: '100%',
    ...(process.env.IS_DEV && { test10: '10%' }),
  };

  useEffect(() => {
    if (props?.selectedPlan?.isPromoCode) {
      setIsPromoCode(props?.selectedPlan?.isPromoCode);
      setIsApplied(false);
    } else {
      setIsPromoCode(false);
    }
  }, [props?.showCard]);

  if (!stripe || !elements) return null;

  const parseCouponValue = (promoCode: string, couponList: Record<string, string>): CouponResult => {
    const value = couponList[promoCode.trim()];
    let amount_off: number | null = null;
    let percent_off: number | null = null;

    if (value) {
      if (value.includes('%')) {
        percent_off = parseFloat(value.replace('%', '').trim());
      } else if (value.includes('$')) {
        amount_off = parseInt(value.replace('$', '').trim(), 10);
      }
    }
    return { amount_off, percent_off };
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setLoader(true);

    const cardElement = elements.getElement(CardNumberElement);
    if (!cardElement) {
      return;
    }

    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: 'card',
      card: cardElement,
    });

    if (error) {
      setLoader(false);
      toast.error(error?.message, {
        position: 'top-right',
      });
      return;
    }

    try {
      const { amount_off, percent_off } = parseCouponValue(promoCode.trim(), CoupenList);
      const payload = {
        planId: props?.selectedPlan?.planId,
        paymentMethodId: paymentMethod?.id,
        extRefKey: id,
        fullName: `${firstName || ''} ${lastName || ''}`.trim(),
        realEmail: email,
        amount_off: isApplied ? amount_off : null,
        percent_off: isApplied ? percent_off : null,
      };

      const response = await axios.post(`api/stripe/dyhac/create-subscription`, null, { params: payload });
      if (response?.data?.status === 'success') {
        setIsPaymentDone(true);
        setPlanView(response?.data?.data);
        // if (getStep == 3) {
        //   navigate('/evidence');
        // }

        handleClose();

        await dispatch(getEntity(id));
      } else {
        toast.error(response?.data?.message, {
          position: 'top-right',
        });
      }
    } catch (err) {
      toast.error('Something went wrong', {
        position: 'top-right',
      });
    }
    setLoader(false);
  };

  const handleClose = () => {
    props?.toggle();
    setPromoCode('');
    setFieldErrors({});
    setIsApplied(false);
    setAmount({});
  };

  const handleApply = async () => {
    const { amount_off, percent_off }: any = parseCouponValue(promoCode.trim(), CoupenList);
    if (CoupenList?.[promoCode.trim()]) {
      const price: any = parseInt(props?.selectedPlan?.price.replace('$', '').trim(), 10);
      let finalPrice = price;
      if (percent_off) {
        finalPrice = (price - (price * percent_off) / 100).toFixed(2);
      } else if (amount_off) {
        finalPrice = amount_off;
        // finalPrice = price - amount_off;
      }
      // finalPrice = parseFloat(finalPrice);
      setAmount({ discount: percent_off ? percent_off : amount_off, total: finalPrice });
      setIsApplied(true);
      setEnableApply(false);
      toast.success(`Promo code applied successfully – ${percent_off ? `${percent_off}%` : `$${price - amount_off}`} off!`, {
        position: 'top-right',
      });
    } else {
      toast.error('Promo code not valid', {
        position: 'top-right',
      });
    }
    return;
    // if (promoCode.trim()) {
    //   const payload = {
    //     promocode: promoCode.trim(),
    //     price: parseInt(props?.selectedPlan?.price.replace('$', '').trim(), 10),
    //   };
    //   try {
    //     const resp = await axios.post(`api/stripe/dyhac/verify-promocode`, null, { params: payload });
    //     console.log(resp, 'resppppp-----');
    //     setIsApplied(true);
    //   } catch (error) {
    //     console.log(error, 'error-----');
    //   }
    // }
  };

  const handleContinue = () => {
    setIsPromoCode(false);
  };

  const handleCloseModal = () => {
    setIsPaymentDone(false);
  };

  const handleChange = (e: any) => {
    setPromoCode(e.target.value);
    e.target.value?.length > 1 ? setEnableApply(true) : setEnableApply(false);
  };

  const CARD_ELEMENT_OPTIONS = {
    style: {
      base: {
        fontSize: '16px',
        color: '#32325d',
        '::placeholder': {
          color: '#a0aec0',
        },
      },
      invalid: {
        color: '#fa755a',
      },
    },
  };
  const onClear = () => {
    setIsApplied(false);
    setPromoCode('');
  };

  return (
    <>
      <PaymentDoneModal isPaymentDone={isPaymentDone} handleCloseModal={handleCloseModal} planView={planView} />
      <Modal isOpen={props?.showCard} toggle={() => handleClose()} centered className="plan-modal" keyboard={false} backdrop="static">
        <ModalHeader
          toggle={() => {
            handleClose();
          }}
        >
          {' '}
          {props?.price !== '$0' ? `Subscribe to ${props?.selectedPlan?.title} Plan ` : 'Payment'}
        </ModalHeader>
        <ModalBody>
          {!isPromoCode && (
            <Form onSubmit={handleSubmit}>
              {amount?.total > 0 && <Alert color="primary">You will be charged ${amount?.total}</Alert>}
              <Row className="mb-2 mx-1">
                <FormGroup>
                  <Label for="cardNumber">Card Number</Label>
                  <div className="stripe-field">
                    <CardNumberElement
                      id="cardNumber"
                      options={CARD_ELEMENT_OPTIONS}
                      onChange={e => setFieldErrors(prev => ({ ...prev, cardNumber: e.error?.message || '' }))}
                    />
                  </div>
                  {fieldErrors.cardNumber && <p className="text-danger">{fieldErrors.cardNumber}</p>}
                </FormGroup>
              </Row>
              <Row className="mb-2 mx-1">
                <Col xs="6" className="text-grey">
                  <FormGroup>
                    <Label for="cardExpiry">Expiry Date</Label>
                    <div className="stripe-field">
                      <CardExpiryElement
                        id="cardExpiry"
                        options={CARD_ELEMENT_OPTIONS}
                        onChange={e => setFieldErrors(prev => ({ ...prev, expiry: e.error?.message || '' }))}
                      />
                    </div>
                    {fieldErrors.expiry && <p className="text-danger">{fieldErrors.expiry}</p>}
                  </FormGroup>
                </Col>
                <Col xs="6" className="text-grey">
                  <FormGroup>
                    <Label for="cardCvc">CVC</Label>
                    <div className="stripe-field">
                      <CardCvcElement
                        id="cardCvc"
                        options={CARD_ELEMENT_OPTIONS}
                        onChange={e => setFieldErrors(prev => ({ ...prev, cvc: e.error?.message || '' }))}
                      />
                    </div>
                    {fieldErrors.cvc && <p className="text-danger">{fieldErrors.cvc}</p>}
                  </FormGroup>
                </Col>
              </Row>
              {/* {error && <p className="text-danger">{error}</p>} */}
            </Form>
          )}
          {isPromoCode && (
            <>
              <div className="mb-3">
                <div className="mb-4">
                  <label className="fw-semibold mb-2 d-block">Promo Code</label>
                  <Form
                    onSubmit={e => {
                      e.preventDefault();
                      handleApply();
                    }}
                  >
                    <div className="d-flex align-items-center gap-2">
                      <div className="flex-grow-1 d-flex align-items-center border border-primary rounded px-3" style={{ height: '50px' }}>
                        <Input
                          type="text"
                          className="form-control border-0 shadow-none"
                          placeholder="Enter promo code"
                          value={promoCode}
                          onChange={e => handleChange(e)}
                          disabled={isApplied}
                          style={{ fontWeight: 500, color: '#6c757d' }}
                        />
                        {!isApplied && promoCode && (
                          <Button
                            className="btn btn-link text-muted px-2${amount?.total}"
                            style={{ background: 'transparent', border: 'none', fontSize: '1.2rem' }}
                            onClick={onClear}
                            title="Clear"
                          >
                            &times;
                          </Button>
                        )}
                      </div>
                      {isApplied && <i className="bi bi-check-circle-fill me-2"> </i>}
                      <Button
                        type="submit"
                        className="download-button"
                        style={{
                          fontWeight: 'bold',
                          minWidth: '100px',
                          height: '50px',
                        }}
                        disabled={!enableApply}
                        // onClick={handleApply}
                      >
                        {isApplied ? 'Applied' : 'Apply'}
                      </Button>
                    </div>
                  </Form>
                </div>
              </div>

              <div className="border rounded-2  bg-light">
                {isApplied ? (
                  <>
                    {' '}
                    <div className=" p-4 bg-light">
                      <h6 className="mb-4 fw-bold text-dark">Billing Summary</h6>

                      <Row className="mb-2">
                        <Col xs="6" className="text-grey">
                          Plan Total
                        </Col>
                        <Col xs="6" className="text-end text-grey">
                          ${parseInt(props?.selectedPlan?.price?.replace('$', '').trim(), 10)}
                        </Col>
                      </Row>

                      <Row className="mb-2">
                        <Col xs="6" className="text-grey">
                          Promo Discount
                        </Col>
                        <Col xs="6" className="text-end text-grey">
                          {CoupenList?.[promoCode.trim()]?.includes('%')
                            ? `${amount.discount} %`
                            : `$${parseInt(props?.selectedPlan?.price?.replace('$', '').trim(), 10) - amount.discount}`}
                        </Col>
                      </Row>
                    </div>
                    <div className="bg-grey p-4">
                      <Row>
                        <Col xs="6" className="fw-bold text-dark">
                          Subtotal
                        </Col>
                        <Col xs="6" className="text-end fw-bold bg-grey">
                          ${amount?.total}
                        </Col>
                      </Row>
                    </div>
                  </>
                ) : (
                  <div className="p-4 bg-light text-muted text-center">
                    Promo code not applied. Bill details will appear here once a valid promo code is used.
                  </div>
                )}
              </div>
            </>
          )}
        </ModalBody>
        <ModalFooter>
          {!isPromoCode ? (
            <Button type="submit" className=" feedback-modal download-button" onClick={handleSubmit} disabled={loader}>
              {loader ? 'Payment in Process' : 'Subscribe'}
            </Button>
          ) : (
            <Button type="submit" className=" download-button" onClick={handleContinue} disabled={loader}>
              {' '}
              Proceed to Payment
            </Button>
          )}
        </ModalFooter>
      </Modal>
    </>
  );
};

export default PaymentForm;
